import PopupImage from 'components/Images/OBJECTS.png'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { StyledModalDialog } from '../../Style/style'
import {
  ButtonContainer,
  DisplayImage,
  PopupContent,
  PopupText,
  PrimaryButton,
  SecondaryButton,
  ViewText,
} from '../Dashboard/style'
import RulesCreationTable from '../RulesCreationIndex/RulesCreationTable'

const AlreadySetPopUp = ({
  isOpen,
  setIsOpen,
  data,
  getInstituteRulesById,
  ruleOverwrite,
  ruleId,
  selectedDegreeStreamMap,
}) => {
  const navigate = useNavigate()
  const [isShowRulesTable, setIsShowRulesTable] = useState(false) // Manage RulesTable visibility
  const rulesDetails = useSelector(state => state?.rules?.ruleDetailsById)
  const [selectedObj, setSelectedObj] = useState({})
  const handleClosePopup = () => {
    setIsOpen(false)
    setIsShowRulesTable(false)
    setSelectedObj({})
  }

  const handleYesClick = async () => {
    let payload = {
      ruleIds: data?.map(item => item.id),
      degreeStreamMapIds: selectedDegreeStreamMap,
    }
    const response = await ruleOverwrite(payload, ruleId)
    if (response?.data?.message === 'Success') {
      navigate(`/ruleEngine/rule-creation/${response?.data?.data?.rule?.id}`)
    }
    setIsOpen(false)
    setIsShowRulesTable(false)
    setSelectedObj({})
  }

  const handleViewAllClick = async data => {
    setSelectedObj(data)
    await getInstituteRulesById(data?.id)
    setIsShowRulesTable(true)
  }

  const publishedRule = data?.filter(item => item?.status === 1)
  const draftRule = data?.filter(item => item?.status === 0)

  return (
    <StyledModalDialog
      open={isOpen}
      centered // This prop centers the modal vertically and horizontally
      footer={''}
      maskClosable={false} // Prevent closing the modal when clicking outside
      closable={isShowRulesTable}
      removeSpacing={isShowRulesTable}
      onCancel={() => {
        if (isShowRulesTable) {
          setIsShowRulesTable(false)
        }
      }}
    >
      {isShowRulesTable ? (
        <RulesCreationTable
          readOnly
          showBackArrow={false}
          isContentHidden={false}
          rulesDetails={rulesDetails}
          selectedObj={selectedObj}
        />
      ) : (
        <>
          <DisplayImage>
            <img src={PopupImage} alt="Question Mark" />
          </DisplayImage>
          <div style={{ width: 400, margin: 'auto' }}>
            {publishedRule?.length > 0 ? (
              <>
                <PopupContent textAlign={'left'} fontWeight="700">
                  Rule is already set for
                </PopupContent>
                {publishedRule?.map(item => {
                  return (
                    <PopupText key={item?.id}>
                      {item?.shortForm} - {item.stream}
                      <ViewText
                        paddingLeft="35px"
                        onClick={() => handleViewAllClick(item)}
                      >
                        View rule set
                      </ViewText>
                    </PopupText>
                  )
                })}
              </>
            ) : null}
            {draftRule?.length > 0 ? (
              <>
                <PopupContent textAlign={'left'} fontWeight="700">
                  In draft
                </PopupContent>
                {draftRule?.map(item => {
                  return (
                    <PopupText key={item?.id}>
                      {item?.shortForm} - {item.stream}
                      <ViewText
                        paddingLeft="35px"
                        onClick={() => handleViewAllClick(item)}
                      >
                        View rule set
                      </ViewText>
                    </PopupText>
                  )
                })}
              </>
            ) : null}
            <PopupContent fontSize={'20px'}>
              Do you want to overwrite these?
            </PopupContent>
            <ButtonContainer
              justify="Center"
              paddingLeft="0px"
              paddingRight="0px"
            >
              <SecondaryButton
                Width="64px"
                text="No"
                onClick={handleClosePopup}
              />
              <PrimaryButton Width="64px" text="Yes" onClick={handleYesClick} />
            </ButtonContainer>
          </div>
        </>
      )}
    </StyledModalDialog>
  )
}

export default AlreadySetPopUp
